import {Component, OnInit} from '@angular/core';
import {ExgApplicationTab, IExgTab} from 'exc-tab-v2';
import {ExcTranslation} from 'exc-core-v2';
import {ApplicationService} from '../../services/application.service';
import {ExcSecurityService} from 'exc-security-v2';
import {OeDetailsComponent} from '../../oe/tab/oe-details/oe-details.component';

@Component({
  selector: 'app-settings-main',
  templateUrl: './settings-main.component.html',
  styles: []
})
export class SettingsMainComponent extends ExcTranslation implements IExgTab, OnInit {
  Data: any;
  tabinstance: any;

  constructor(
    public excSecurity: ExcSecurityService,
    private appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  openCaseAutoText($event: MouseEvent): void {
    this.appSvc.AppSettings.Case.AutoTextSettings.OpenTab();
  }

  openCaseDefaultMessage($event: MouseEvent): void {
    this.appSvc.AppSettings.Case.DefaultMessageSettings.OpenTab();
  }

  openCaseDefaultDocuments($event: MouseEvent): void {
    this.appSvc.AppSettings.Case.DefaultDocumentSettings.OpenTab();
  }

  openTaskAutoText($event: MouseEvent): void {
    this.appSvc.AppSettings.Task.AutoTextSettings.OpenTab();
  }

  openTaskDefaultMessage($event: MouseEvent): void {
    this.appSvc.AppSettings.Task.DefaultDocumentSettings.OpenTab();
  }

  openTaskDefaultDocuments($event: MouseEvent): void {
    this.appSvc.AppSettings.Task.DefaultDocumentSettings.OpenTab();
  }

  openTaskDialogQuestions($event: MouseEvent): void {
    this.appSvc.AppSettings.Task.DialogQuestionSettings.OpenTab();
  }

  openTaskForms($event: MouseEvent): void {
    // this.appSvc.AppSettings.Task.FormsSettings.OpenTab();
    new ExgApplicationTab(
      'OEDetails'
      , OeDetailsComponent
      , 'F897D70D-03ED-473C-B632-340170CE398D'
      , 'ba37a3fd-9010-40e5-8490-cb6ac66d191a'
    ).Open();
  }

  openDefaultOE($event: MouseEvent): void {
    this.appSvc.OE.Workspace.OpenDefaultOETab('00000000-0000-0000-0000-000000000000');
  }

  openTaskScheduleTemplate($event: MouseEvent): void {
    this.appSvc.AppSettings.Task.ScheduleTemplateSettings.OpenTab();
  }

  openGlobal($event: MouseEvent): void {
    this.appSvc.AppSettings.GlobalSettings.OpenTab();
  }
}
